export default String.raw`
{% if config.External.Edrone.AppId != '' -%}
    <script>
        if(cookieSettingsValue == undefined || cookieSettingsValue == 'granted' || cookieSettingsValue[0] == 'granted'){
            (function (srcjs) {
                window._edrone = window._edrone || {};
                _edrone.app_id = '{{ config.External.Edrone.AppId }}';
                _edrone.version = '1.0.0';
                _edrone.platform_version = '{{ config.Version }}';
                _edrone.platform = 'comarch';
                _edrone.shop_lang = '{{ page.Language }}';

                {% if page.PageId != config.DefinedPages.Order.Id -%}
                    _edrone.action_type = 'other';
                    {% if usr.Authenticated -%}
                        {% if customer.Address.Name != '' -%}
                            {% assign FullName = customer.Address.Name -%}
                            {% if FullName contains ' ' -%}
                                {% assign HalfName = FullName | Split:' ' -%}
                            {% endif %}
                            _edrone.first_name = '{% if HalfName[0] -%}{{ HalfName[0] }}{% else %}{{ FullName }}{% endif %}';
                            {% if HalfName[1] -%}
                                _edrone.last_name = '{{ HalfName[1] }}';
                            {% endif %}
                        {% endif -%}
                        {% if customer.Address.Country != '' -%}
                            _edrone.country = '{{ customer.Address.Country }}';
                        {% endif -%}
                        {% if customer.Address.City != '' -%}
                            _edrone.city = '{{ customer.Address.City }}';
                        {% endif -%}
                        {% if customer.Address.Phone != '' -%}
                            _edrone.phone = '{{ customer.Address.PhoneNo }}';
                        {% endif -%}
                        _edrone.email = '{{ customer.Email }}';
                    {% endif -%}
                {% endif -%}

                var doc = document.createElement('script');
                doc.type = 'text/javascript';
                doc.async = true;
                doc.src = ('https:' == document.location.protocol ? 'https:' : 'http:') + srcjs;
                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(doc, s);
            })("//d3bo67muzbfgtl.cloudfront.net/edrone_2_0.js");
        }
    </script>
{% endif -%}
`